import { NavLink } from "react-router";
import { useAlbumStore, useProfilStore } from "../stores/useStore";
import { observer } from "mobx-react-lite";
import Header from "../components/general/Header";
import "../style/Home.css";

const Home = observer(() => {
  const albumStore = useAlbumStore();
  const profilStore = useProfilStore();

  return (
    <>
      <main className="home_main">
        <Header admin={profilStore.admin} linkList={[]} responsive={false} connected={profilStore.isConnected} imageProfil={profilStore.isConnected&&profilStore.profilPicture?profilStore.profilPicture:undefined}/>
        <div className="home_mainContent">
          <NavLink to="/play/param" className="home_link">
            <p>PLAY</p>
          </NavLink>
          <NavLink to="/collection" className="home_link2">
            <p>Voir la collection</p>
          </NavLink>
          <NavLink to="/community" className="home_link2">
            <p>Communauté</p>
          </NavLink>
          { profilStore.isConnected ? 
          <NavLink to="/profil" className="home_link2">
            <p>Mon profil</p>
          </NavLink>
           :
          <NavLink to="/login" className="home_link2">
            <p>Connexion</p>
          </NavLink>
          }
        </div>
      </main>
    </>
  );
});

export default Home;
